export { default } from "./Typography-component";
